import { useFaturamentoPermissions } from '../../../hooks/useFaturamentoPermissions'
import { Loader2 } from 'lucide-react'
import PremiacaoAdministrador from './PremiacaoAdministrador'
import PremiacaoTime from './PremiacaoTime'

function Premiacao() {
  const { isAdmin, isAnalista, isLoading } = useFaturamentoPermissions()

  if (isLoading)
    return (
      <div className="flex items-center justify-center h-64">
        <Loader2 className="w-8 h-8 animate-spin text-brand-500" />
      </div>
    )

  if (isAdmin)
    return <PremiacaoAdministrador />

  if (isAnalista)
    return <PremiacaoTime />

  return (
    <div className="bg-white rounded-xl p-6 border border-gray-200 shadow-theme-sm">
      <div className="text-center py-12">
        <p className="text-gray-600">Você não tem permissão para acessar esta funcionalidade.</p>
      </div>
    </div>
  )
}

export default Premiacao
